<template>
<div class="checkout-container" v-if="currentCustomer">
    <div class="main-checkout">   
        <div class="centered">
        <div class="aside-responsive x-scroll">
            <p class="pointer aside-responsive-content" @click="RouterPush('/identificarse')">
                <span class="fa-stack" ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 1 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">1</span></span>
            </span>
            Inicio de sesíon
            </p>

            <p class="pointer aside-responsive-content" @click="ChangeCheckoutStep(2)">
            <span class="fa-stack" ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 2 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">2</span></span>
            </span>
            Direccion de envío
            </p>

            <p class="pointer aside-responsive-content" @click="ChangeCheckoutStep(3)">
            <span class="fa-stack"  ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 3 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">3</span></span>
            </span>
            Verificación de orden
            </p>
            <p class="pointer aside-responsive-content" @click="ChangeCheckoutStep(4)">
            <span class="fa-stack" ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 4 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">4</span></span>
            </span>
            Horario de entrega
            </p>
            <p class="pointer aside-responsive-content" @click="ChangeCheckoutStep(5)">
            <span class="fa-stack"  ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 5 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">5</span></span>
            </span>
            Método de pago
            </p>
            <p class="pointer aside-responsive-content"  @click="ChangeCheckoutStep(6)">
            <span class="fa-stack " ><i class="fas fa-circle fa-stack-1ax" :class="{ 'active-step' : checkoutStep === 6 }"></i>
                <span class="fa fa-stack-1x" style="color:red;"><span class="step">6</span></span>
            </span>
            Confirmación de orden
            </p>
        </div>

        <!--Address-->
        <div  v-if="checkoutStep === 'ShippingAddressStep'" >
            <Addresses/>
        </div>
        <!--Address-->

        <!--Order check-->
            <form @submit.prevent="Agree" class="profile" v-if="checkoutStep === 'OrderConfirmationStep'">
                <h2 class="form-title">Verificación de orden</h2>
                <div class="x-scroll">
                <table class="ui table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Producto</th>
                            <th>Disponible en sucursal</th>
                            <th>Cantidad</th>
                            <th>Precio unitario</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody v-if="productEntries && productEntries.length !== 0">
                        <tr v-for="(entry,index) in productEntries" :key="index" class="border-bottom">
                            <td><i v-if="entry.type==='PRODUCT_ENTRY'" class="fas fa-times" @click="AddRawProduct( {product: entry.product, quantity: (entry.delta * -1)})" style="color:var(--light-blue)"></i></td>
                            <td ><span class="discount-table" v-if="entry.type==='DISCOUNT'">Descuento</span> {{entry.product.name}}</td>
                            <td v-if="entry.type === 'SHIPPING'"></td>
                            <td v-else-if="entry.product.available===true">Si</td> <td v-else class="row-danger">Sobre pedido</td>
                            <td><span v-if="entry.type==='PRODUCT_ENTRY'">{{entry.delta}}</span></td>
                            <td><span v-if="entry.type==='PRODUCT_ENTRY'">{{(entry.amount + entry.amountTax) | to-currency-from-cents}}</span></td>
                            <td><span>{{entry.delta* ( entry.amountTax +  entry.amount ) | to-currency-from-cents}}</span></td>
                        </tr>  
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Total de la orden</td>
                            <td></td>
                            <td></td>
                            <td>{{orderTotals.total | to-currency-from-cents}}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="table-info">
                    <p class="small-margins">*En productos genéricos, la presentación de los laboratorios pueden variar.</p> 
                    <p class="small-margins">*Las imagenes publicadas son meramente ilustrativas y pueden diferir del producto entregado.</p>
                    <p class="small-margins">*Por seguridad, no se aceptan cambios ni devoluciones. Le pedimos verificar su orden al recibirla.</p>
                </div>
                <div class="mid-container">
                    <button class="ui blue button wide"  style="margin-top: 0.625rem;" type="submit">Estoy de acuerdo con los productos y precios</button>
                    <button class="ui default button wide" type="button" @click="PreviousStep" style="margin-top: 0.625rem;"><i class="fa fa-angle-left  icon-space-right"></i>Regresar</button>
                </div>
            </form>  
        <!--Order check-->

        <!--time to delivery-->
            <form @submit.prevent="TimeConfirm" class="profile" v-if="checkoutStep === 'ShippingProfileStep'">
                <h2 class="form-title">Horario de entrega</h2>
                <p class="form-title">Seleccione el tipo de envío que desee utilizar.</p>
                <input type="text" hidden name="deliveryType" id="deliveryType">
                <div class="x-scroll">
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>Tipo de envio</th>
                            <th>Compromiso</th>
                            <th>Precio</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="pointer">
                            <td v-if="shippingProfile.canBeExpress" @click="DeliveryType('express')">
                                <i class="fas fa-check-square" data-delivery="Express" :class="{ 'delivery-inactive' : deliveryType==='express' ? true:false }"></i>Envío express
                            </td>
                            <td v-else>El envío no puede ser express en esta dirección</td>
                            <td>En menos de 1 hora</td>
                            <td>{{GetShippingProductAmount('envio-express') | to-currency-from-cents }}</td>
                        </tr> 
                        <tr v-if="order.isSelfSufficient" class="pointer">
                            <td @click="DeliveryType('reg')"><i class="fas fa-check-square" data-delivery="Reg" :class="{ 'delivery-inactive' : deliveryType==='reg' ? true:false }"></i>Envío regular</td>
                            <td>En menos de {{shippingProfile.regularTimespan}} hora(s)</td>
                            <td>{{GetShippingProductAmount('envio') | to-currency-from-cents }}</td>
                        </tr> 
                         <tr v-if="!order.isSelfSufficient" class="pointer">
                            <td @click="DeliveryType('reg')"><i class="fas fa-check-square" data-delivery="Reg" :class="{ 'delivery-inactive' : deliveryType==='reg' ? true:false }"></i>Envío regular</td>
                            <td>En menos de {{shippingProfile.programmedTimespan}} hora(s)</td>
                            <td>$10.00</td>
                        </tr> 
                        <tr class="pointer">
                            <td @click="DeliveryType('programmed')"><i class="fas fa-check-square"  data-delivery="Program" :class="{ 'delivery-inactive' : deliveryType==='programmed' ? true:false }"></i>Envío programado </td>
                            <td>
                                <input v-if="!order.isSelfSufficient" type="date" name="dateToDelivery" :disabled="deliveryType!=='programmed'" :data-offset="shippingProfile.transferTimespan" :data-step="currentShippingProfile.regularTimespan" :data-branch-id="order.branch && order.branch.id" @change="RetrieveSaturationTimes">
                                <input v-if="order.isSelfSufficient" type="date" name="dateToDelivery" :disabled="deliveryType!=='programmed'" :data-step="shippingProfile.regularTimespan" :data-branch-id="order.branch && order.branch.id" @change="RetrieveSaturationTimes">
                                <select class="time" name="timeToDelivery" id="timeToDelivery" :disabled="deliveryType!=='programmed'">
                                    <option selected disabled>Seleccione un rango de horas</option>
                                    <option v-for="(data,index) in ranges" :key="index" :value="data.start+'|'+data.end" :disabled="data.naturalMinutes > 0 && ( data.naturalMinutes - data.saturatedMinutes ) < ranges.minutes">{{data.saturationRangeString}}</option>
                                </select>
                            </td> 
                            <td>$10.00</td>
                        </tr>  
                    </tbody>
                </table>
                </div>
                <div class="mid-container">
                    <button type="submit" class="ui blue button wide" :disabled="shippingProfile.isRegularSaturated">Confirmo horario de entregas</button>
                    <button class="ui default button wide" type="button" @click="PreviousStep"><i class="fa fa-angle-left" style="padding-rigth"></i>Regresar</button>
                </div>
            </form>  
        <!--time to delivery-->

        <!--payment method-->
            <div v-if="checkoutStep === 'PaymentStep'" class="profile">
                <h2 class="form-title">Método de pago</h2>
                <form @submit.prevent="PaymentMethod" class="profile">
                    <p class="form-title">Agrege el metodo de pago que desee utilizar</p>
                    <select class="checkout-control left" required name="payment" id="payment" >
                        <option value="" selected disabled >Seleccione el metodo de pago</option>
                        <option value="CASH">Efectivo</option>
                        <option value="DEBIT_CARD">Tarjeta de Débito</option>
                        <option value="CREDIT_CARD">Tarjeta de Crédito</option>
                        <option value="CREDIT_LINE">Línea de Crédito</option>
                        <option value="BANK_TRANSFER">Transferencia Bancaria</option>
                        <option value="UBER_EATS">Uber Eats</option>
                    </select>
                    <input class="checkout-control left" type="text" required name="quantity" id="quantity" placeholder="Cantidad" />
                    <div class="mid-container">
                        <button class="ui blue button wide" type="submit">Agregar método de pago</button>
                    </div>
                </form>

                <form @submit.prevent="AddCoupon" class="profile"> 
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>Descuento</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <select class="input-table left" type="text" required name="coupon" id="coupon">
                                    <option value="">Seleccione cupon</option>
                                    <option v-for="(data,index) in coupons" :key="index" :value="data.id">{{data.name}}</option>
                                </select>
                            </td>
                            <td style="text-align:right"><button class="ui blue button" type="submit">Seleccionar<i class="fa fa-angle-right"></i></button></td>
                        </tr>
                    </tbody>
                </table>
                </form>
                <form @submit.prevent="ConfirmPayment" class="profile">
                    <div class="x-scroll">
                        <table class="ui table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Método de pago</th>
                                    <th></th>
                                    <th>Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data,index) in paymentMethodEntries" :key="index">
                                    <td><i v-if="data" class="fas fa-times pointer" style="color:var(--light-blue)" @click="RemovePaymentMethod(data.id)"></i></td>
                                    <td v-if="data">{{$t(data.paymentMethodType)}}</td> <td v-else></td>
                                    <td v-if="data!=null"></td><td v-else>Aun no se ha agregado ningún método de pago</td>
                                    <td>{{data.amount | to-currency-from-cents}}</td>
                                </tr>
                                <tr v-if="couponEntries.length>0" >
                                    <td><i class="fas fa-times pointer"  style="color:var(--light-blue)" @click="RemoveCoupon"></i></td>
                                    <td class="coupon-description" v-if="couponEntries!==null"><b>Cupon aplicado:</b>{{couponEntries[0].description}}</td><td v-else>-</td>
                                    <td></td>
                                    <td>-{{couponEntries[0].amount | to-currency-from-cents}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align:right">Total de métodos de pago </td>
                                    <td >{{orderTotals.paymentMethods | to-currency-from-cents }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align:right">Total de orden </td>
                                    <td>{{orderTotals.total | to-currency-from-cents}}</td>
                                </tr>
                                <tr v-if="orderTotals.pendingToExpress > 0">
                                    <td></td>
                                    <td></td>
                                    <td style="text-align:right">Pendiente por Expresar </td>
                                    <td>{{orderTotals.pendingToExpress  | to-currency-from-cents}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td style="text-align:right">Cambio</td>
                                    <td>{{orderTotals.change | to-currency-from-cents}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-info">
                        <p>*Por su comodidad, el repartidor llevara el cambio exacto</p>
                    </div>
                    <div class="mid-container">
                        <button class="ui blue button wide" >Confirmar método de pago</button>
                        <button class="ui default button wide" type="button" @click="PreviousStep"><i class="fa fa-angle-left" ></i>Regresar</button>
                    </div>
                </form>
            </div>
            <!--payment method-->

            <!--order confirm-->
            <form v-on:submit.prevent="PublishOrder" class="profile" :class="{'hidden': checkoutStep !== 'OrderVerificationStep'}">
                <h2 class="form-title">Confirmación de orden</h2>
                <div class="x-scroll">
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>Dirección</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-if="order.shippingAddress">{{order.shippingAddress.cleanName}}</td><td v-else>-</td>
                            <td style="text-align:right"><div class="ui blue button" @click="ChangeCheckoutStep('ShippingAddressStep')">Cambiar<i class="fa fa-angle-right"></i></div></td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="x-scroll">
                <table class="ui table">
                    <thead>
                        <tr>
                            <th>Método de pago</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><div v-for="(data,index) in paymentMethodEntries" :key="index">{{$t(data.paymentMethodType)}} -> {{data.amount | to-currency-from-cents}}</div></td>
                            <td style="text-align:right"><div class="ui blue button" @click="ChangeCheckoutStep('PaymentStep')">Cambiar<i class="fa fa-angle-right"></i></div></td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="x-scroll">
                <table class="ui table">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                 <select class="input-table left" type="text"  name="coupon" id="coupon">
                                    <option value="">Cupón de descuento</option>
                                    <option v-for="(data,index) in coupons" :key="index" :value="data.id">{{data.name}}</option>
                                </select></td>
                            <td style="text-align:right"><div class="ui blue button">Aplicar cupon<i class="fa fa-angle-right"></i></div></td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="x-scroll">
                 <table class="ui table">
                    <thead>
                        <tr>
                            <th>Resumen</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Costo de productos</td>
                            <td></td>
                            <td>{{orderTotals.total - orderTotals.shippingProfileTotal - orderTotals.discounts | to-currency-from-cents}}</td>
                        </tr>
                        <tr>
                            <td>Costo de envío</td>
                            <td></td>
                            <td>{{orderTotals.shippingProfileTotal | to-currency-from-cents}}</td>
                        </tr>
                        <tr>
                            <td>Descuentos</td>
                            <td></td>
                            <td>{{orderTotals.discounts | to-currency-from-cents}}</td>
                        </tr>
                        <tr v-if="couponEntries.length>0">
                            <td style="font-weight:bold" v-if="couponEntries!==null">Cupon aplicado: {{couponEntries[0].description}} </td><td v-else>-</td>
                            <td></td>
                            <td>-{{couponEntries[0].amount | to-currency-from-cents}}</td>
                        </tr>
                        <tr>
                            <td> </td>
                            <td style="text-align:right; font-weight:bold">Total</td>
                            <td style="font-weight:bold" >{{orderTotals.total | to-currency-from-cents}}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="mid-container">
                    <button class="ui blue button wide" type="submit">Realizar orden</button>
                    <button class="ui default button wide" type="button" @click="PreviousStep"><i class="fa fa-angle-left" style="padding-rigth"></i>Regresar</button>
                </div>
            </form>    
            <!--order confirm-->    
        </div>
           
    </div>
    
    <div class="aside-checkout">
        <div class="pointer container-flex row" data-step="LoginStep" style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : !currentCustomer, 'completed-step': currentCustomer}">
                <span v-if="!currentCustomer">1</span>
                <span v-else>✔</span>
            </span>
            Inicio de sesíon
        </div>

        <div class="pointer container-flex row" @click="RequestCheckoutStepChange" data-step="ShippingAddressStep" :data-step-available="currentCustomer !== null"  style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : checkoutStep === 'ShippingAddressStep' , 'completed-step': order.shippingAddress}">
                <span v-if="!order.shippingAddress">2</span>
                <span v-else>✔</span>
            </span>
            Direccion de envío
        </div>

        <div class="pointer container-flex row" @click="RequestCheckoutStepChange" data-step="OrderConfirmationStep" :data-step-available="order.shippingAddress !== null" style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : checkoutStep === 'OrderConfirmationStep' , 'completed-step': order.confirmed !== null && order.confirmed}">
                <span v-if="!order.confirmed">3</span>
                <span v-else>✔</span>
            </span>
            Verificación de orden
        </div>

        <div class="pointer container-flex row" @click="RequestCheckoutStepChange" data-step="ShippingProfileStep" :data-step-available="order.confirmed !== null && order.confirmed" style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : checkoutStep === 'ShippingProfileStep' , 'completed-step': order.lowerBoundDelivery !== null}">
                <span v-if="!order.lowerBoundDelivery">4</span>
                <span v-else>✔</span>
            </span>
            Horario de entrega
        </div>

        <div class="pointer container-flex row" @click="RequestCheckoutStepChange" data-step="PaymentStep" :data-step-available="order.lowerBoundDelivery !== null" style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : checkoutStep === 'PaymentStep' , 'completed-step': orderTotals.pendingToExpress <= 0}">
                <span v-if="orderTotals.pendingToExpress > 0">5</span>
                <span v-else>✔</span>
            </span>
            Método de pago
        </div>

        <div class="pointer container-flex row" @click="RequestCheckoutStepChange" data-step="OrderVerificationStep" :data-step-available="orderTotals.pendingToExpress <= 0" style="margin-bottom: 1em">
            <span class="step" :class="{ 'active-step' : checkoutStep === 'OrderVerificationStep' }">
                <span>6</span>
            </span>
            Confirmación de orden
        </div>
    </div>
</div>
</template>

<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAgXYwmEyjyrfh05bQvYAchiB33tLDAIQ8"></script>
<script>
import { mapActions, mapState } from 'vuex'
import Addresses from '../components/Addresses'
export default {
    name:'Checkout',
    components: {
        Addresses
    },
    data(){
        return{
            deliveryType:0
        }
    },
    beforeMount(){
        // -- Send the user directly to the login page if there are not logged on
        if(!this.currentCustomer){
            this.RouterPush('/identificarse')
        // -- Infer current step from order situation
        }else{
            this.$store.dispatch('GetUserAddresses')
        }
    },
    mounted() {
        // -- Using query selection to get the last available step
        let currentAvailableStep = Array.from( document.querySelectorAll('[data-step-available]') ).slice(-1).pop();

        // -- Set current step to the last available step. if not found just default to shipping address step
        this.$store.commit('StateAssign', { checkoutStep: !currentAvailableStep ? 'ShippingAddressStep' : currentAvailableStep.dataset.step })
    },
    methods:{
        RequestCheckoutStepChange(e){
            let targetStep = e.target.dataset.step
            let stepAvailable = e.target.dataset.stepAvailable
            let currentStep = this.$store.state.checkoutStep;
            let targetStepIndex = this.$store.state.checkoutSteps.indexOf( targetStep );
            let currentStepIndex = this.$store.state.checkoutSteps.indexOf( currentStep );

            // -- Dont continue if on stame step
            if( currentStep === targetStep ) return;

            // -- If the step we are trying to access is the next step, but that step is not available
            // do not jump to it.
            if( targetStepIndex > currentStepIndex && !stepAvailable ){
                return;
            }

            this.$store.commit('StateAssign',{loginFromCart: false})
            this.$store.commit('StateAssign',{checkoutStep: targetStep})
        },
        GetShippingProductAmount( productSlug ){
            if( !this.$store.state.shippingProducts ) return 0;
            let shippingProduct = this.$store.state.shippingProducts.find( ( p ) => p.slug === productSlug );
            return shippingProduct.regularPrice + shippingProduct.regularPriceTax;
        },
        PreviousStep(){
            let currentStepIndex = this.$store.state.checkoutSteps.indexOf( this.$store.state.checkoutStep );
            let previousStep = this.$store.state.checkoutSteps[ currentStepIndex - 1 ];
            this.$store.commit('StateAssign', { checkoutStep: previousStep })
        },
        DeliveryType(type){
            this.deliveryType = type
            document.getElementById('deliveryType').value = type
        },
        ChangeCheckoutStep( step ){
            this.$store.commit('StateAssign', { checkoutStep: step })
        },
        ...mapActions(['RouterPush','EditAddress','Agree','TimeConfirm','PaymentMethod','ConfirmPayment','AddCoupon','RemovePaymentMethod','RemoveCoupon','AddRawProduct','RetrieveSaturationTimes','PublishOrder'])
    },
    computed:{
        ...mapState(['paymentMethod','discountCoupon','cords','markers','productEntries','checkoutStep','currentCustomer','loginFromCart','order','orderTotals','ranges','coupons','paymentMethodEntries','couponEntries','shippingProfile'])
    }
}
</script>

<style scoped>
th, td{
    text-align:left;
    padding:.5rem;
}
.table-info{
    padding-left:2rem;
    text-align: left;
    padding-bottom:1rem;
    font-weight: bold;
    font-size: .9rem;
}

.btn-light-blue{
    width: 40%;
    font-weight: bold;
    color: white;
    margin-bottom: 1rem;
}
.discount-table{
    font-weight: bold;
    text-decoration: underline;
}
.time{
   height: 1.55rem;
   margin-left: .5rem;

}
.step{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background: gray;
    color: white;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: .6em;
}
.step *{
    color:white;
}
.coupon-description{
    width:20rem;
}
.border-bottom  {
  border-bottom: 1px solid rgba(189, 189, 189, 0.473);
}
.fa-stack{
    width: 1rem;
} 
.fa-angle-right, .fa-angle-left{
    color:#fafafa;    
}
.checkout-container{
    display: flex;
	flex-flow: row-reverse wrap;
	margin: auto;
    justify-content: center;
}
.main-checkout, .aside-checkout{
    flex: 0 100%;
    height: auto;
}

.main-checkout{
    justify-content: center;
    width: 100%;
}
.delivery-inactive{
    color:var(--light-blue);
}

.completed-step{
    background:var(--light-green);
}

.active-step{
    background:var(--light-blue);
}

.checkout-control {
    width: 100%;
    min-height: 1.5625rem;
    padding: 0.3125rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom: 1em;
    text-align: left;
    box-sizing: border-box;
  
}
@media (min-width: 37.5rem){
    .main-checkout{
        flex:1 0 0px;
        height: auto;
        
    }
    .aside-checkout{
        flex: 0 0 12.5rem;
        height: auto;
        text-align: left;
        padding-left: 1.25rem;
    }
}

@media (max-width: 49rem) {
    .aside-checkout{
        display: none;
    }

    .aside-responsive{
        display: flex;
    }
}


</style>